import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import isoWeek from 'dayjs/plugin/isoWeek';
import 'dayjs/locale/de';
import 'dayjs/locale/sv';

dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(isoWeek);
